"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudFlow = exports.useCrudFlow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var Button_1 = require("../../atoms/Button");
var LoadingIndicator_1 = require("../../atoms/LoadingIndicator");
var FullScreenDialogContent_1 = require("../../atoms/FullScreenDialogContent");
var FullScreenDialogNavBar_1 = require("../../molecules/FullScreenDialogNavBar");
var molecules_1 = require("../../molecules");
var FullScreenDialog_1 = require("../../organisms/FullScreenDialog");
// should not need to export this outside of this component
var CrudContext = (0, react_1.createContext)({
    dirty: false,
    setDirty: function () { },
});
// for use inside of crud views to access CrudFlow state
var useCrudFlow = function () { return (0, react_1.useContext)(CrudContext); };
exports.useCrudFlow = useCrudFlow;
/* Dialog Content with optional wrapper */
var DialogWrapper = react_1.default.memo(function (_a) {
    var content = _a.children, standalone = _a.standalone;
    // TODO: fix typings that prevent fragment from being used
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return standalone ? ((0, jsx_runtime_1.jsx)(FullScreenDialog_1.FullScreenDialog, __assign({ open: true }, { children: content }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content }));
});
exports.CrudFlow = react_1.default.memo(function (_a) {
    var idPrefix = _a.idPrefix, title = _a.title, subtitle = _a.subtitle, _b = _a.entityName, entityName = _b === void 0 ? "record" : _b, // ASK: should we default
    // behavioral flags
    _c = _a.promptWhenClosing, // ASK: should we default
    // behavioral flags
    promptWhenClosing = _c === void 0 ? true : _c, _d = _a.saveRequiresDirty, saveRequiresDirty = _d === void 0 ? true : _d, standalone = _a.standalone, _e = _a.dirty, defaultDirty = _e === void 0 ? false : _e, 
    // content
    additionalButtons = _a.additionalButtons, children = _a.children, 
    // flags for available actions
    _f = _a.actionable, 
    // flags for available actions
    actionable = _f === void 0 ? true : _f, saveable = _a.saveable, deleteable = _a.deleteable, editable = _a.editable, 
    // state for content
    loading = _a.loading, 
    // state for actions
    saving = _a.saving, deleting = _a.deleting, _g = _a.closeDisabled, closeDisabled = _g === void 0 ? false : _g, 
    // action callbacks
    _h = _a.onSave, 
    // action callbacks
    onSave = _h === void 0 ? function () { } : _h, _j = _a.onClose, onClose = _j === void 0 ? function () { } : _j, _k = _a.onDelete, onDelete = _k === void 0 ? function () { } : _k, _l = _a.onEdit, onEdit = _l === void 0 ? function () { } : _l;
    var _m = (0, react_1.useState)(false), showClosePrompt = _m[0], setShowClosePrompt = _m[1];
    var _o = (0, react_1.useState)(false), showDeletePrompt = _o[0], setShowDeletePrompt = _o[1];
    var _p = (0, react_1.useState)({
        dirty: defaultDirty,
    }), state = _p[0], setState = _p[1];
    /* Close Handlers */
    var handleClose = function () {
        if (state.dirty && promptWhenClosing) {
            setShowClosePrompt(true);
        }
        else {
            onClose();
        }
    };
    var handleCloseConfirm = function () {
        onClose();
    };
    var handleCloseCancel = function () {
        setShowClosePrompt(false);
    };
    /* Delete Handlers */
    var handleDelete = (0, react_1.useCallback)(function () {
        setShowDeletePrompt(true);
    }, []);
    var handleDeleteConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onDelete()];
                case 1:
                    _a.sent();
                    setShowDeletePrompt(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteCancel = function () {
        setShowDeletePrompt(false);
    };
    /* Save Handlers */
    var handleSave = (0, react_1.useCallback)(function () {
        onSave();
    }, [onSave]);
    /* Edit Handlers */
    var handleEdit = (0, react_1.useCallback)(function () {
        onEdit();
    }, [onEdit]);
    /* Context Helpers */
    var setDirty = (0, react_1.useCallback)(function (dirty) {
        setState(__assign(__assign({}, state), { dirty: dirty }));
    }, [setState, state]);
    /* Buttons */
    var buttons = (0, react_1.useMemo)(function () {
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (0, react_common_lib_1.includeInArray)(deleteable, {
            id: "".concat(idPrefix, "DeleteButton"),
            children: "Delete",
            onClick: handleDelete,
            color: "error",
            variant: "text",
            loading: deleting,
        }), true), (additionalButtons || []), true), (0, react_common_lib_1.includeInArray)(saveable, {
            id: "".concat(idPrefix, "SaveButton"),
            children: "Save",
            onClick: handleSave,
            loading: saving,
            variant: "contained",
            disabled: saveRequiresDirty && !state.dirty, // you can only save if you have made changes
        }), true), (0, react_common_lib_1.includeInArray)(editable, {
            id: "".concat(idPrefix, "EditButton"),
            children: "Edit",
            onClick: handleEdit,
            variant: "contained",
        }), true).map(function (buttonProps) { return ((0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ "data-testid": buttonProps.id }, buttonProps), buttonProps.id)); });
    }, [
        additionalButtons,
        deleteable,
        deleting,
        editable,
        handleDelete,
        handleEdit,
        handleSave,
        idPrefix,
        saveRequiresDirty,
        saveable,
        saving,
        state.dirty,
    ]);
    var providerValue = react_1.default.useMemo(function () { return ({
        dirty: state.dirty,
        setDirty: setDirty,
    }); }, [setDirty, state.dirty]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(DialogWrapper, __assign({ standalone: standalone }, { children: [(0, jsx_runtime_1.jsx)(FullScreenDialogNavBar_1.FullScreenDialogNavBar, { title: title, subtitle: subtitle, buttons: actionable ? buttons : undefined, onClose: handleClose, closeDisabled: closeDisabled }), (0, jsx_runtime_1.jsx)(FullScreenDialogContent_1.FullScreenDialogContent, { children: (0, jsx_runtime_1.jsx)(CrudContext.Provider, __assign({ value: providerValue }, { children: (0, jsx_runtime_1.jsx)(LoadingIndicator_1.LoadingIndicator, __assign({ loading: loading }, { children: children })) })) })] })), showClosePrompt && ((0, jsx_runtime_1.jsx)(molecules_1.ConfirmDialog, __assign({ title: "Are you sure...", onCancel: handleCloseCancel, onConfirm: handleCloseConfirm, confirmText: "Continue", cancelText: "Cancel", open: true }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["All changes to this ", entityName, " will be lost."] }), (0, jsx_runtime_1.jsx)("p", { children: "Click \"Continue\" to proceed without saving." })] }) }))), showDeletePrompt && ((0, jsx_runtime_1.jsx)(molecules_1.ConfirmDialog, __assign({ title: "Are you sure...", confirmText: "Continue", cancelText: "Cancel", onConfirm: handleDeleteConfirm, onCancel: handleDeleteCancel, loading: deleting, open: true }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["This ", entityName, " will be deleted and cannot be undone"] }), (0, jsx_runtime_1.jsx)("p", { children: "Click \"Continue\" to proceed" })] }) })))] }));
});
